export function checkIsValidComponent(fields, formFields) {
    if (fields.hasOwnProperty(formFields)) {
        let componentFields = Object.keys(fields[formFields]);

        if (componentFields.some(key => fields[formFields][key].touched)) {
            return !componentFields.some(key => fields[formFields][key].invalid);
        }
    }
    return false;
}

export function autoFocusNextInput(event, rootElement) {
    const element = event.target;

    if (element.tagName === 'INPUT' && element.value.length === parseInt(element.getAttribute('maxlength'))) {
        if (!element.classList.contains('error')) {
            const inputs = rootElement.getElementsByTagName('input');
            const elementIndex = [...inputs].indexOf(element);
            const nextElement = [...inputs][elementIndex + 1];

            if (nextElement) {
                nextElement.focus();
            }
        }
    }
}